import { ImagePickerConf } from 'ngp-image-picker';
import { Injectable } from "@angular/core";
@Injectable()
export class ExtentedHelper {
  ConvertEnumToObjects(DefinedEnum) {
    return Object.keys(DefinedEnum)
      .filter((f) => !isNaN(Number(f)))
      .map((k) => parseInt(k));
  }
}

export function toBase64(file: File) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

// Max Size Unit KB
export function FileSizeValidation(filesize: number, maxsize: number): boolean {
  if (Math.round(filesize / 1024) > maxsize) {
    return true;
  } else {
    return false;
  }
  }
  const imageExts:string[] = ["jpg",
    "png",
    "gif",
    "webp",
    "flif",
    "cr2",
    "tif",
    "bmp",
    "jxr",
    "psd",
    "ico",
    "bpg",
    "jp2",
    "jpm",
    "jpx",
    "heic",
    "cur",
    "dcm"];

export function IsFileImage(Exts:string):boolean {
  if(imageExts.filter(a=>a === Exts).length > 0)
  return true;
  else
  return false;
}

export function  isNumerics (val: string) : boolean {
  return !isNaN(Number(val));
}

export const config2: ImagePickerConf = {
  borderRadius: '5px',
  language: 'en',
  width: '100%',
  objectFit: 'scale-down',
  aspectRatio: 1,
  compressInitial: 50,
};
